
import styled from 'styled-components'
export const ContainerItemNewsLaboratory = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-position: center;
`
